<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible="dialog"
      width="500px"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      @close="close"
      @open="open"
    >
      <el-form ref="challenge" :model="challenge" label-position="top">
        <el-form-item
          label="Wallet"
          prop="wallet"
        >
          <el-input type="text" v-model="challenge.wallet" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
    <Preview :previewText="text" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Preview from '@/global/components/Preview'

export default {
  components: {
    Preview
  },
  data() {
    return {
      text: '',
      fileList: [],
      url: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    }
  },

  computed: {
    dialogTitle: function() {
      if (
        typeof this.challenge.id !== 'undefined' &&
        this.challenge.id !== null
      )
        return 'Edit wallet'
      else {
        return 'Insert wallet'
      }
    },
    ...mapState('youtubeShorts', [
      'loading',
      'challenge',
      'data',
      'dialog',
      'user_types'
    ])
  },

  methods: {
    ...mapActions('youtubeShorts', ['update']),
    ...mapMutations('youtubeShorts', ['setSelectedChallenge', 'setDialog']),
    ...mapMutations('global', ['setPreview']),

    submit() {
      if (
        typeof this.challenge.id !== 'undefined' &&
        this.challenge.id !== null
      )
        this.update(this.challenge.id)
      else this.insert()
    },

    onSuccess(response, file) {
      this.challenge.image_url = response.response.message
      this.$message({
        type: 'success',
        message: `File ${file.name} uploaded`
      })
    },

    onError(err) {
      var res = JSON.parse(err.message)
      this.$message({
        type: 'error',
        message: res ? res.response.message : 'Upload error!'
      })
    },

    onRemove() {
      this.challenge.image_url = null
    },

    onExceed() {
      this.$message({
        type: 'error',
        message: 'Only one image can be uploaded'
      })
    },

    open() {
    },

    close() {
      this.setDialog(false)
    }
  }
}
</script>

<style scoped>
</style>
